import React, {createRef} from "react";
import {useFormikContext} from "formik";
import {Grid} from '@mantine/core';
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";
import useStyles from '../styles';
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";

export default function TitularForm(props) {

    const {
        formField: {name, lastName, phone, email, postCode, dni},
        localidadesData
    } = props;
    const {values, setFieldValue} = useFormikContext();
    const classes = useStyles();
    const ref = createRef();

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={name.name}
                        label={name.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={lastName.name}
                        label={lastName.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={phone.name}
                            label={phone.label}
                            value={values.phone}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(phone.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={postCode.name}
                        label={postCode.label}
                        data={localidadesData}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
